module.exports = __webpack_public_path__ + "img/icon-category-camper-bg.8f2cb4d6.jpg";